import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

// Votacion de poker de una tarea (mas reciente, abierta o cerrada).
// staleTime corto porque queremos picking changes rapidos cuando otros
// votan. Sin polling automatico — el usuario tiene un boton "Actualizar"
// (decision de F5: sin tiempo real para no complicar la infra).
export function usePoker(taskId: number | null) {
  return useQuery({
    queryKey: ['poker', taskId],
    queryFn: () => api.poker.get(taskId!),
    enabled: taskId !== null,
    staleTime: 15 * 1000,
  });
}

export function useIniciarPoker() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ taskId, escala }: { taskId: number; escala?: number[] }) =>
      api.poker.iniciar(taskId, escala),
    onSuccess: (_data, { taskId }) => {
      qc.invalidateQueries({ queryKey: ['poker', taskId] });
    },
  });
}

export function useVotarPoker() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ taskId, valor, esInterrogante }: { taskId: number; valor: number | null; esInterrogante: boolean }) =>
      api.poker.votar(taskId, valor, esInterrogante),
    onSuccess: (_data, { taskId }) => {
      qc.invalidateQueries({ queryKey: ['poker', taskId] });
    },
  });
}

export function useCerrarPoker() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (taskId: number) => api.poker.cerrar(taskId),
    onSuccess: (_data, taskId) => {
      qc.invalidateQueries({ queryKey: ['poker', taskId] });
      // Cerrar tambien actualiza HorasEstimadas en la tarea — invalidar
      // queries de tasks para que el TaskModal recargue ese campo.
      qc.invalidateQueries({ queryKey: ['task', taskId] });
      qc.invalidateQueries({ queryKey: ['tasks'] });
    },
  });
}
